module.exports = __webpack_public_path__ + "img/zaluzie-priprava-cast.7c71dac7.svg";